import { UserRole } from "../model/user-role.model";

export const DEFAULT_ROUTE_BY_ROLE: Record<UserRole, string> = {
  agent: 'dashboard',
  uw_assist: 'work-view',
  underwriter: 'work-view'
};